/** The zones the library page can display, in the order the header group renders them. */
export enum LibraryZone {
  Chat = 'chat',
  Library = 'library',
}
